import { useI18n } from "../hooks/useI18n"
import { HeaderLogo } from "./MainFigmaVisuals"
import "./AppHeader.css"

type Tone = "neutral" | "primary" | "danger"

type HeaderAction = {
  label: string
  onClick?: () => void
  tone?: Tone
  ariaLabel?: string
  className?: string
}

type Props = {
  left?: HeaderAction
  right?: HeaderAction
}

export function AppHeader({ left, right }: Props) {
  const { direction } = useI18n()

  return (
    <header className="bbf-app-header">
      {left && (
        <button
          type="button"
          className={`bbf-app-header-action left ${left.tone || "neutral"}`}
          onClick={left.onClick}
          aria-label={left.ariaLabel || left.label}
          tabIndex={left.onClick ? 0 : -1}
        >
          <span dir={direction}>{left.label}</span>
        </button>
      )}

      <HeaderLogo />

      {right && (
        <button
          type="button"
          className={`bbf-app-header-action right ${right.tone || "neutral"}${right.className ? ` ${right.className}` : ""}`}
          onClick={right.onClick}
          aria-label={right.ariaLabel || right.label}
          tabIndex={right.onClick ? 0 : -1}
        >
          <span dir={direction}>{right.label}</span>
        </button>
      )}
    </header>
  )
}
